<div class="wizard-stepper">
  @for (label of steps; track label; let i = $index; let last = $last) {
    <button
      type="button"
      class="step"
      [class.active]="isActive(i)"
      [class.done]="isDone(i)"
      (click)="onClick(i)"
      >
      <div class="circle">
        @if (isDone(i)) {
          <mat-icon>check</mat-icon>
        }
        @if (!isDone(i)) {
          <span>{{ i + 1 }}</span>
        }
      </div>
      <span class="label">{{ label }}</span>
    </button>
    @if (!last) {
      <div class="connector" [class.done]="isDone(i)"></div>
    }
  }
</div>
